function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasportizace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 148.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "197.5 128.17 128.5 145.83 68.83 129.83 2.5 145.17 2.5 19.5 68.83 4.17 128.5 20.17 197.5 2.5 197.5 128.17",
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.83,
    y1: 122.17,
    x2: 68.83,
    y2: 116.17,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.83,
    y1: 102.64,
    x2: 68.83,
    y2: 28.26,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeDasharray: "0 0 13.52 13.52",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.83,
    y1: 21.5,
    x2: 68.83,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.5,
    y1: 135.83,
    x2: 128.5,
    y2: 129.83,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.5,
    y1: 116.31,
    x2: 128.5,
    y2: 41.93,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeDasharray: "0 0 13.52 13.52",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.5,
    y1: 35.17,
    x2: 128.5,
    y2: 29.17,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.5,51.2v-20.32c-8.69,8.66-41.34,36-50.87,40.5-11.27,5.32-21.13,8.22-21.22,8.25-.22.06-.44.14-.66.22l-53.32,21.03c-6.11-7.24-18.95-22.45-28.83-34.15l27.37-4.15c2.51-.38,4.65-2,5.7-4.31l21.18-46.59-14.69-3.94-18.47,40.62-32.46,4.93c-.9-1.06-1.5-1.77-1.7-2-2.05-2.39-19.86-21.42-21.89-23.58-1.39-1.49-3.25-2.28-5.14-2.36v18.82c7.01,7.5,14.56,15.62,15.64,16.88,1.96,2.29,44.86,53.11,45.3,53.62,1.46,1.72,3.57,2.66,5.73,2.66.92,0,1.85-.17,2.75-.52l58.03-22.88c.67-.2,2.22-.68,4.4-1.42l21.93,46.21,14.81-3.79-22.72-47.87c1.52-.66,3.07-1.36,4.67-2.11,8.6-4.06,29.93-20.98,44.46-33.75Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.03,38h-8.58v-8.58c0-1.38-1.12-2.5-2.5-2.5s-2.5,1.12-2.5,2.5v8.58h-8.58c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5h8.58v8.58c0,1.38,1.12,2.5,2.5,2.5s2.5-1.12,2.5-2.5v-8.58h8.58c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.69,109.33h-8.58v-8.58c0-1.38-1.12-2.5-2.5-2.5s-2.5,1.12-2.5,2.5v8.58h-8.58c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5h8.58v8.58c0,1.38,1.12,2.5,2.5,2.5s2.5-1.12,2.5-2.5v-8.58h8.58c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasportizace);
export default __webpack_public_path__ + "static/media/pasportizace.1b0d6cda4b3d6f0080c8de15f87c4d00.svg";
export { ForwardRef as ReactComponent };